import type {ReactAction} from '@netx/core/bootstrap';
import {faLifeRing} from '@netx/core-icons';
import {spawnNewWindow} from '@netx/core-next/utils/browser';
import {getPublicProperty} from '../utils/getPublicProperty';
import {AppPref} from '../constants';
import {canAccessHelpCenter} from '../enablers';
import {AppContactLabel} from '../locales';

export const appActionHelpCenterIcon = faLifeRing;

/**
 * Route to contact
 * @param params
 * @returns Action
 */
export const appActionHelpCenter = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'app-help-center',
	cb: () => {
		spawnNewWindow(getPublicProperty(AppPref.HELP_URL) ?? '');
	},
	enableTest: () => canAccessHelpCenter(),
	icon: appActionHelpCenterIcon,
	get label() {
		return AppContactLabel.HELP_CENTER;
	},
	...params,
});
